/**
 * opsRuns.ts — Operations › Runs: every ad run, social run and background job in one list, newest first.
 */
import { z } from "zod";

export const OPS_RUN_SOURCES = ["ads", "social", "job"] as const;
export const OPS_RUN_SOURCE_LABEL: Record<(typeof OPS_RUN_SOURCES)[number], string> = { ads: "Ads", social: "Social", job: "Background job" };

export const opsRunSchema = z.object({
  id: z.string(),
  source: z.enum(OPS_RUN_SOURCES),
  /** "LinkedIn ads", "Social ideas", or the job's own name. */
  label: z.string(),
  product: z.string().nullable(),
  status: z.enum(["running", "done", "failed", "partial"]),
  trigger: z.string(),
  startedAt: z.string(),
  finishedAt: z.string().nullable(),
  /** "Grok + Claude" and so on; null when no model was involved or none was recorded. */
  models: z.string().nullable(),
  produced: z.number().int().nullable(),
  error: z.string().nullable(),
});
export type OpsRun = z.infer<typeof opsRunSchema>;
export const opsRunsResponseSchema = z.object({ items: z.array(opsRunSchema) });
export type OpsRunsResponse = z.infer<typeof opsRunsResponseSchema>;
